export class Tweezer {
  duration: number;
  ease: Function;
  start: number;
  end: number;

  frame: number | null;
  next: any;
  isRunning: boolean;
  events: Object;
  direction: string;
  timeStart: number | null;
  timeElapsed: number;

  constructor(opts: any = {}) {
    this.duration = opts.duration || 1000;
    this.ease = opts.easing || this.defaultEase;
    this.start = opts.start;
    this.end = opts.end;
    this.timeStart = 0;
    this.timeElapsed = 0;
    this.frame = null;
    this.next = null;
    this.isRunning = false;
    this.events = {} as any;
    this.direction = this.start < this.end ? "up" : "down";
  }

  begin() {
    if (!this.isRunning && this.next !== this.end) {
      this.frame = window.requestAnimationFrame(this.tick.bind(this));
    }
    return this;
  }

  stop() {
    window.cancelAnimationFrame(Number(this.frame));
    this.isRunning = false;
    this.frame = null;
    this.timeStart = null;
    this.next = null;
    return this;
  }

  on(name: string, handler: Function) {
    (this.events as any)[name] = (this.events as any)[name] || [];
    (this.events as any)[name].push(handler);
    return this;
  }

  private emit(name: string, val: number | null) {
    let e = (this.events as any)[name];
    e && e.forEach((handler: any) => handler.call(this, val));
  }

  private tick(currentTime: number) {
    this.isRunning = true;

    let lastTick = this.next || this.start;

    if (!this.timeStart) this.timeStart = currentTime;
    this.timeElapsed = currentTime - this.timeStart;
    this.next = Math.round(
      this.ease(
        this.timeElapsed,
        this.start,
        this.end - this.start,
        this.duration
      )
    );

    if (this.shouldTick(lastTick)) {
      this.emit("tick", this.next);
      this.frame = window.requestAnimationFrame(this.tick.bind(this));
    } else {
      this.emit("tick", this.end);
      this.emit("done", null);
    }
  }

  private shouldTick(lastTick: any): boolean {
    return ({
      up: this.next < this.end && lastTick <= this.next,
      down: this.next > this.end && lastTick >= this.next
    } as any)[this.direction];
  }

  /* http://blog.moagrius.com/actionscript/jsas-understanding-easing/
@t is the current time (or position) of the tween. This can be seconds or frames, steps, seconds, ms, whatever – as long as the unit is the same as is used for the total time.
@b is the beginning value of the property. (usually is 0)
@c is the change between the beginning and destination value of the property. (usually is 1)
@d is the total time of the tween.  
  */
  private defaultEase(t: number, b: number, c: number, d: number) {
    if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
    return (-c / 2) * (--t * (t - 2) - 1) + b;
  }
}
